document.addEventListener("click", (event) => {
  const eventTarget = event.target instanceof Element ? event.target : null;
  const loginLink = eventTarget?.closest("[data-retec-account-login]");

  if (!loginLink || !customElements.get("shopify-account")) return;

  const accountComponents = Array.from(document.querySelectorAll("shopify-account"));
  const accountComponent =
    accountComponents.find((component) => component.getClientRects().length > 0) || accountComponents[0];
  const signedOutAvatar = accountComponent?.querySelector('[slot="signed-out-avatar"]');

  if (!signedOutAvatar) return;

  event.preventDefault();
  signedOutAvatar.click();
});
